import DOMPurify from "dompurify";

export const DOCUMENT_TYPES = [
  { label: "Privacy Policy", value: "privacy_policy" },
  { label: "Cookie Policy", value: "cookie_policy" },
  { label: "Return Policy", value: "return_policy" },
  { label: "Admin Terms", value: "admin_term" },
  { label: "Seller Terms", value: "seller_term" },
  { label: "Buyer Terms", value: "buyer_term" },
  { label: "Data Processing Agreement", value: "data_processing_agreement" },
  { label: "Prohibited Items & Brand Protection", value: "prohibited_items" },
  { label: "Trust & Safety / Disputes", value: "trust_safety" },
  { label: "Product Sync", value: "product-sync" },
];
export const VISIBILITIES = [
  { label: "Everyone", value: "EVERYONE" },
  { label: "Seller", value: "SELLERS_ONLY" },
  { label: "Buyer", value: "BUYERS_ONLY" },
];
export const STATUSES = ["DRAFT", "PUBLISHED", "ARCHIVED"];

export const humanize = (value) =>
  value ? String(value).toLowerCase().split("_").map((part) => part.charAt(0).toUpperCase() + part.slice(1)).join(" ") : "—";
export const formatVersion = (value) => `v${Number.isFinite(Number(value)) && Number(value) > 0 ? Number(value) : 1}`;
export const getDocumentHtmlContent = (document = {}) => {
  const value = document.content ?? document.body ?? "";
  if (typeof value === "string") return value;
  return value?.html ?? value?.Content ?? value?.content ?? "";
};
export const getDocumentNlHtmlContent = (document = {}) => {
  const value = document.content ?? document.body ?? "";
  if (typeof value === "object") return value?.content_nl ?? value?.html_nl ?? value?.Content_nl ?? "";
  return document.content_nl ?? "";
};
export const getDocumentTitle = (document = {}, language = "EN", fallback = "Untitled document") =>
  language === "NL"
    ? document.titleNl ?? document.title_nl ?? document.name_nl ?? document.title ?? fallback
    : document.title ?? document.name ?? fallback;
export const getDocumentContent = (document = {}, language = "EN") =>
  language === "NL" ? getDocumentNlHtmlContent(document) : getDocumentHtmlContent(document);
export const sanitizeHtml = (html) => DOMPurify.sanitize(html || "", {
  USE_PROFILES: { html: true },
  FORBID_TAGS: ["script", "iframe", "object", "embed"],
  FORBID_ATTR: ["onerror", "onload", "onclick"],
});
export const stripHtmlForPreview = (content, max = 110, emptyText = "No content available") => {
  const clean = sanitizeHtml(typeof content === "object" ? getDocumentHtmlContent({ content }) : content);
  const node = document.createElement("div");
  node.innerHTML = clean;
  const text = (node.textContent || "").replace(/\s+/g, " ").trim();
  if (!text) return emptyText;
  return text.length > max ? `${text.slice(0, max).trim()}…` : text;
};
export const apiError = (error, fallback) =>
  error?.response?.data?.message ?? error?.response?.data?.error ?? error?.message ?? fallback;
